import React, { useEffect, useState } from "react";
import { TextField, Pagination, Stack } from "@mui/material";
import DeleteConfirm from "../DeleteConfirm/index";
import axios from "axios";

import Box from "./Box";
import "./style.css";

export default function AllIbcc({ setChooseBox }) {
  const [deleteConfirm, setDeleteConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [edit, setEdit] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // debounced search
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");


  const handleDelete = async () => {
    try {
      setLoading(true);
      setDeleteConfirm("");
      const response = await axios.delete(process.env.REACT_APP_BACKEND + "/record/delete/" + deleteConfirm);
      console.log(response);
      setData((prev) => prev?.filter((item) => item._id !== deleteConfirm));
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();
      const response = await axios.put(process.env.REACT_APP_BACKEND + "/record/update/" + edit._id, {
        ...edit,
      });
      console.log({ response });
      setEdit(null);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  const handleVisibility = async (id, status) => {
    try {
      setLoading(true);
      await axios.put(process.env.REACT_APP_BACKEND + "/record/update-visibility/" + id, { status });
      const response = await axios.get(
        process.env.REACT_APP_BACKEND + "/record/all",
        {
          params: {
            page,
            limit,
            search,
          },
        }
      );

      setData(response.data.data);
      setTotalPages(response.data.pagination.totalPages);

    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    !edit &&
      (async function () {
        try {
          setLoading(true);
          const response = await axios.get(
            process.env.REACT_APP_BACKEND + "/record/all",
            {
              params: {
                page,
                limit,
                search,
              },
            }
          );

          setData(response.data.data);
          setTotalPages(response.data.pagination.totalPages);

        } catch (error) {
          console.log({ error });
        } finally {
          setLoading(false);
        }
      })();
  }, [edit, page, search]);


  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(searchInput);
      setPage(1);
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchInput]);


  if (loading)
    return (
      <div className="loader-main">
        <div className="loading" />
      </div>
    );
  return (
    <>
      {deleteConfirm && <DeleteConfirm onCancel={() => setDeleteConfirm("")} onConfirm={handleDelete} />}

      {edit && (
        <div className="edit-form">
          <form onSubmit={handleEdit}>
            {Object.entries(edit).map(([key, val]) => {
              if (["status", "document", "code", "_id"].includes(key)) return;
              return (
                <div className="input-main">
                  <label>{key}:</label>
                  <input
                    type={"text"}
                    value={val}
                    onChange={(e) =>
                      setEdit((prev) => {
                        const update = { ...prev };
                        update[key] = e.target.value;
                        return update;
                      })
                    }
                  />
                </div>
              );
            })}
            <button type="submit">Save</button>
            <button onClick={() => setEdit(null)}>Cancel</button>
          </form>
        </div>
      )}
      <Stack spacing={2} sx={{ pt: 5, mx: "auto", width: "300px" }}>
        <TextField
          label="Search by name"
          variant="outlined"
          size="medium"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </Stack>
      <div className="all-apostille-main">
        {data?.map((item, i) => (
          <Box {...item} key={i} onDelete={(id) => setDeleteConfirm(id)} onEdit={setEdit} onVisibilityChange={handleVisibility} onQR={setChooseBox} />
        ))}
      </div>
      <Stack spacing={2} alignItems="center" sx={{ my: 4 }}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
          shape="rounded"
          size="large"

        />
      </Stack>

      <div className="btn-container">
        <button className="done-button" onClick={() => setChooseBox("")}>
          Done
        </button>
      </div>
    </>
  );
}
